<div class="container-fluid">
  <div class="row">
    <!-- <div class="alert alert-danger text-center mt-2" *ngIf="msgError">{{errorMessage}}</div> -->

    <div class="col-12" *ngIf="msgError">
      <div class="alert-box grid-100" *ngIf="errorMessage">
        <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert">×</a>
        {{errorMessage}}
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="successError">
      <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert">×</a>
        {{successMessage}}
        </div>
      </div>
    </div>
    <div class="col-3 mt-5 pull-right">
    <span style="font-weight: bold;">DIGITAL NOC</span> 
  </div>
  <div class="col-9 mt-5 d-flex justify-content-end">
    <button class="addCursor downloadBtn mr-2 btn mb-1"
                (click)="downloadLeadData()">
                Download Excel Report
              </button>
    </div>
  </div>
  <div class="row">
    <div class="col-6 mt-3">
      <input
                type="text"
                name="searchInput"
                class="w-100"
                placeholder="Search For Lead Id,Customer,GM,CM,Designer"
                (keydown.enter)="searchFilter($event)"
              />
    </div>  
  </div>
  <div class="row">
    <div class="col-8 filter2 mt-3">
      <span class="fltype">Filter by Flag</span>
        <span class="fltype" style="margin-left:4rem;">Select Flag Type</span>
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearFlagFilter()" style="font-size: 12px">Clear</span>
        <div class="floptions">
          <!-- <span class="active mr-3" [ngClass]="{'active': delayed_data == ''}" (click)="redflagclick('')">All</span> -->
          <button style="width: 42px;" type="button" class="btn active btn-sm col_buttons mr-3" name="button" (click)="redflagclick(1)" [ngClass]="{'active': delayed_data == 1}">All</button>
    
      <img src="../../../../assets/img/flag-yellow-neww.png" style="height: 33px;"/><button type="button" style="width: 132px;" class="btn btn-sm col_buttons mr-3" name="button" (click)="redflagclick('yellow')" [ngClass]="{'active': delayed_data == 'yellow'}">(Delayed by 1 Day)</button>
     
      <img src="../../../../assets/img/flag-orange-neww.png" style="height: 33px;"/><button type="button" style="width: 147px;" class="btn btn-sm col_buttons mr-3" name="button" (click)="redflagclick('orange')" [ngClass]="{'active': delayed_data == 'orange'}">(Delayed by 2-5 Days)</button>
      
      <img src="../../../../assets/img/flag-red-neww.png" style="height: 33px;"/><button type="button" class="btn btn-sm col_buttons" style="width: 147px;" name="button" (click)="redflagclick('red')" [ngClass]="{'active': delayed_data == 'red'}">(Delayed by > 5 Days)</button>
    </div>
    </div>  
  
  <!-- <div class="row mt-4"> -->
    <div class="col-7 filter2 mt-3">
        <span class="fltype">Filter by DATE</span>
        <span class="fltype" style="margin-left:4rem;">Select Actual Date Range</span>
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearDateFilter()" style="font-size: 12px">Clear</span>
        <div class="floptions d-flex">
            <input [owlDateTime]="dt1" style="width: 100px;" [owlDateTimeTrigger]="dt1" placeholder="Select Date"  class=" rk-form-fontsize d-block rounded px-2 p-1" [(ngModel)]="from_date" >
		    <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time> <span style="font-weight:lighter;" class="ml-2 mt-1"> To </span>
		    <input [owlDateTime]="dt2" style="width: 100px;" [owlDateTimeTrigger]="dt2" placeholder="Select Date"  class=" rk-form-fontsize d-block  rounded px-2 ml-2 p-1" [attr.value]="to_date | date: 'yyyy-MM-dd'" [(ngModel)]="to_date" [min]="from_date">
        <owl-date-time #dt2 [pickerType]="'calendar'" ></owl-date-time>
        <select class="ml-3" style="width: 201px;" (change)="dateDropDownChanged($event.target.value)">
          <option value="" selected>Select Task</option>
          <!-- <option *ngFor="let date_data of date_values" [value]="date_data">{{date_data | replaceChar}}</option> -->
          <option value="sent_to_production_date">Sent to Production Date</option>
          <option value="forty_per_payment_at">40% Payment Date</option>
          <option value="final_boq_approved_at">Final BOQ Approved Date</option>
          <option value="final_boq_shared_at">Final BOQ Shared Date</option>
          <option value="qc_approved_date">QC Approved Date</option>
          <option value="qc_request_date">QC Request Date</option>
          <option value="material_selection_date">Material Selection Date</option>
          <option value="site_validation_date">Site Validation Date</option>
          <option value="site_measurement_date">Site Measurement Date</option>
          <option value="ten_per_payment_at">10% Payment Date</option>
          <option value="initial_boq_approved_at">Inital BOQ Approved Date</option>
          <option value="initial_boq_shared_at">Inital BOQ Shared Date</option>
          <option value="first_meeting_at">First Meeting Date</option>
          <option value="first_call_at">First Call Date</option>
          <option value="qualification_date">Qualification Date</option>
          <option value="acquisition_date">Acquisition Date</option>
        </select>
        <button class="btn btn-sm go-filter ml-3" (click)="submitByDate()">GO</button>
        <!-- <button class="btn btn-sm go-filter ml-3" (click)="submitByDate()">GO</button> -->
        </div>
    </div>
  </div>

<!-- </div> -->
  <div class="row">
    <div class="col-md-3 filter2 ml-4" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'|| role =='city_gm' || role=='design_manager'}">
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearGmFilter()" style="font-size: 12px">Clear</span>
          <span class="fltype">Filter by GM</span>
        <div class="floptions">
            <angular2-multiselect [data]="gm_dropdownList" [(ngModel)]="selectedGmItems"
            [settings]="gm_dropdownSettings"
            (onSelect)="onItemSelect($event,'gm',3)"
            (onDeSelect)="OnItemDeSelect($event,'gm',3)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
          </div>
      </div>
    <div class="col-md-3 filter2" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'}" [ngStyle]="{'margin-left':(role =='city_gm' || role=='design_manager') ? '2%':'0%'}">
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearCmFilter()" style="font-size: 12px">Clear</span>
          <span class="fltype">Filter by CM</span>
        <div class="floptions">
            <angular2-multiselect [data]="cm_dropdownList" [(ngModel)]="selectedCmItems"
            [settings]="cm_dropdownSettings"
            (onSelect)="onItemSelect($event,'cm',1)"
            (onDeSelect)="OnItemDeSelect($event,'cm',1)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
          </div>
  
      </div>
      <div class="col-md-3 filter2" [ngClass]="{'d-none': role =='designer'}">
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="CleardesignerFilter()" style="font-size: 12px">Clear</span>
          <span class="fltype">Filter by DESIGNER</span>
          <div class="floptions">
            <angular2-multiselect [data]="designer_dropdownList" [(ngModel)]="selectedDesignerItems"
            [settings]="designer_dropdownSettings"
            (onSelect)="onItemSelect($event,'designer',2)"
            (onDeSelect)="OnItemDeSelect($event,'designer',2)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
          </div>
      </div>
    <div class="col-md-4 filter2">
        <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearAreaFilter()" style="font-size: 12px">Clear</span>
          <span class="fltype">Filter by Feature</span>
          <div class="floptions">
              <button type="button" class="btn  active btn-sm col_buttons" name="button" (click)="getfeatured('')" [ngClass]="{'active': featured == ''}">All</button>
              <button type="button" class="btn  btn-sm col_buttons" name="button" (click)="getfeatured('true')" [ngClass]="{'active': featured == 'true'}">Featured</button>
              <button type="button" class="btn  btn-sm col_buttons" name="button" (click)="getfeatured('false')" [ngClass]="{'active': featured == 'false'}">Non-Featured</button>
          </div>
      </div>
  </div>  
  <div class="row">
    <div class="col-12 mt-5">
      <table>
         <tr class="bg_color">
          <th scope="col" class="padd-lead"></th>
          <th scope="col" class="padd-lead">Lead ID</th>
          <th scope="col" class="padd-lead">Customer Name</th>
          <th scope="col" class="padd-lead">Type Of Product</th>
          <th scope="col" class="padd-lead">Lead Acquisition Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('acquisition_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('acquisition_date', 'desc')"></i></th>
          <th scope="col" class="padd-lead">Lead Qualification Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qualification_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qualification_date', 'desc')"></i></th>
          <th scope="col" style="padding-right: 10rem !important;">GM</th>
          <th scope="col" style="padding-right: 10rem !important;">CM</th>
          <th scope="col" class="padd-lead">Designer</th>
          <th scope="col" class="padd-lead">First Call <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('first_call_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('first_call_at', 'desc')"></i></th>
          <th scope="col" class="padd-lead">First Meeting <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('first_meeting_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('first_meeting_at', 'desc')"></i></th>
          <th scope="col" class="padd-lead">Initial BOQ Shared <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('initial_boq_shared_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('initial_boq_shared_at', 'desc')"></i></th>
          <th scope="col" class="padd-lead">Initial BOQ Approval <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('initial_boq_approved_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('initial_boq_approved_at', 'desc')"></i></th>
          <th scope="col" class="padd-lead">10% Payment <i class="fa fa-arrow-down" aria-hidden="true" (click)="orderChange('ten_per_payment_at','asc')" style="cursor: pointer;"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('ten_per_payment_at', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Site Measurement Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('site_measurement_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('site_measurement_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Material Selection Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('material_selection_date','asc')"></i><i class="fa fa-arrow-up" style="cursor: pointer;" aria-hidden="true" (click)="orderChange('material_selection_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Site Validation Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('site_validation_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('site_validation_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">QC Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qc_request_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qc_request_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">QC Approved Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qc_approved_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('qc_approved_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Final BOQ Shared <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('final_boq_shared_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('final_boq_shared_at', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Final BOQ Approval <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('final_boq_approved_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('final_boq_approved_at', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">40% Payment Date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('forty_per_payment_at','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('forty_per_payment_at', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Sent to Production date <i class="fa fa-arrow-down" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('sent_to_production_date','asc')"></i><i class="fa fa-arrow-up" aria-hidden="true" style="cursor: pointer;" (click)="orderChange('sent_to_production_date', 'desc')"></i></th>
          <th scope="col" class="padd-right-lead">Project Handover</th>
          <th style="padding-left: 2rem;"></th>
          </tr> 
          <ng-container *ngFor="let data of items | paginate
          : {
              itemsPerPage: per_page,
              currentPage: current_page,
              totalItems: total_page
            }; let i=index">
            <tr class="row_style" style="cursor: pointer;">
              <td *ngIf="!data.featured" class="pl-3" (click)="featureddata(data.lead_id)"><img src="../../../../assets/img/star@3x.png" style="height: 20px;"/></td>
              <td *ngIf="data.featured" class="pl-3" (click)="removefeatureddata(data.lead_id)"><img src="../../../../assets/img/star-featured.png" style="height: 20px;"/></td>
              <td>{{data.lead_id}}</td>
            <td (click)="toggleRow(data,i); getBOQdetails(data.lead_id,i)">{{data.customer_name}}</td>
              <td>{{data.lead_tags | qwert}}</td>
              <td>{{data.acquisition_date}}</td>
              <td>{{data.qualification_date}}</td>
              <td >{{data.gm.name}}</td>
              <td>{{data.cm.name}}</td>
              <td >{{data.designer.name}}</td>
              <td>{{data.first_call.date}}</td>
              <td>{{data.first_meeting.date}}<span *ngIf="data && data.first_meeting.data && data.first_meeting.data.length !== 0" class="pl-1"><a data-toggle="modal" data-target="#firstmeetingModal" ><i
                style="font-size:20px" (click)="firstmeeting(data.first_meeting.data)" class="fa ">&#xf05a;</i></a></span></td>
              <td>{{data.initial_boq_shared}}</td>
              <td>{{data.initial_boq_approved | date:'dd/MM/yyyy - h:mm a'}}</td>
              <td>{{data.ten_per_payment.date}}<span *ngIf="data && data.ten_per_payment.data && data.ten_per_payment.data.length !== 0" class="pl-1"><a data-toggle="modal" data-target="#tanModal" ><i
                style="font-size:20px; cursor: pointer;" (click)="tenpayment(data.ten_per_payment.data)" class="fa ">&#xf05a;</i></a></span></td>
                <td><div><b>Ideal</b> - {{data.timeline["Initial Site Measurement Request"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Expected</b> - {{data.timeline["Initial Site Measurement Request"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Actual</b> - {{data.timeline["Initial Site Measurement Request"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                <td><div><b>Ideal</b> - {{data.timeline["Material Finalisation Meeting"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Expected</b> - {{data.timeline["Material Finalisation Meeting"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Actual</b> - {{data.timeline["Material Finalisation Meeting"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td><div><b>Ideal</b> - {{data.timeline["Site Validation Request"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Expected</b> - {{data.timeline["Site Validation Request"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Actual</b> - {{data.timeline["Site Validation Request"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td><div><b>Ideal</b> - {{data.timeline["Final BOQ Category Handover"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Expected</b> - {{data.timeline["Final BOQ Category Handover"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Actual</b> - {{data.timeline["Final BOQ Category Handover"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td><div><b>Ideal</b> - {{data.timeline["Final BOQ Category Approved"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Expected</b> - {{data.timeline["Final BOQ Category Approved"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Actual</b> - {{data.timeline["Final BOQ Category Approved"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td><div><b>Ideal</b> - {{data.timeline["Final BOQ Shared"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Expected</b> - {{data.timeline["Final BOQ Shared"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Actual</b> - {{data.timeline["Final BOQ Shared"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td><div><b>Ideal</b> - {{data.timeline["Final BOQ approved"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Expected</b> - {{data.timeline["Final BOQ approved"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
              <div><b>Actual</b> - {{data.timeline["Final BOQ approved"].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
              <td>
                <div><b>Ideal</b> - {{data.timeline["40% payment mapped (Sent to Production)"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Expected</b> - {{data.timeline["40% payment mapped (Sent to Production)"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Actual</b> - {{data.timeline["40% payment mapped (Sent to Production)"].actual | date:'dd/MM/yyyy - h:mm a'}}<span *ngIf="data && data.forty_per_payment.data && data.forty_per_payment.data.length !==0" class="pl-1"><a data-toggle="modal" data-target="#fortyModal" ><i
                  style="font-size:20px; cursor: pointer;" (click)="fortypayments(data.forty_per_payment.data)" class="fa ">&#xf05a;</i></a></span></div>
                </td>
                <td><div><b>Ideal</b> - {{data.timeline["40% payment mapped (Sent to Production)"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Expected</b> - {{data.timeline["40% payment mapped (Sent to Production)"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
                <div><b>Actual</b> - {{data.timeline["40% payment mapped (Sent to Production)"].actual | date:'dd/MM/yyyy - h:mm a'}}</div>
                </td>

                <td><div><b>Ideal</b> - {{data.timeline["Project Handover"].ideal | date:'dd/MM/yyyy - h:mm a'}}</div>
                  <div><b>Expected</b> - {{data.timeline["Project Handover"].expected | date:'dd/MM/yyyy - h:mm a'}}</div>
                  <div><b>Actual</b> - {{data.timeline["Project Handover"].actual | date:'dd/MM/yyyy - h:mm a'}}</div>
                  </td>
              <td class="" [ngClass]="{'active': selectedArrow == i}"><i class="fa fa-angle-down" style="font-size: 25px; cursor: pointer;" (click)="toggleRow(data,i); getBOQdetails(data.lead_id,i)"></i>
              </td>
              </tr>

              <!-- <div class = "CirclePoint" *ngFor="let c of circles" [attr.id]="'Location' + c.id"> </div> <div class = "CirclePoint" *ngFor="let c of circles" attr.id="Location{{c.id}}"> </div> -->
           <!--Cascading View Starts--> 
          <!-- <ng-container *ngIf="showDetails">   -->
              <tr *ngIf="data && data.expanded" attr.id="Location{{i}}" style="background-color: #fff9fa;" class="location">
                <td colspan="11" class="p-0">
            <table>
            <tr>
              <th scope="col" style="padding-left: 1rem;" class="padd-right">BOQ Number</th>
              <!-- <th scope="col" style="padding-right: 12rem;"></th> -->
              <th scope="col" style="padding-right: 12rem;">Tags</th>
              <th scope="col" class="padd-right">Initial BOQ Shared</th>
              <th scope="col" class="padd-right">Initial BOQ Approval</th>
              <th scope="col" class="padd-right">10% Payment</th>
              <th scope="col" class="padd-right-lead">QC Date</th>
              <th scope="col" class="padd-right-lead">QC Approve Date</th>
              <th scope="col" class="padd-right-lead">Final BOQ Shared</th>
              <th scope="col" class="padd-right-lead">Final BOQ Approval</th>
              <th scope="col" class="padd-right-lead">40% Payment Date</th>
              <th scope="col" class="padd-right-lead">Sent to Production Date</th>
              </tr>
              <ng-container *ngFor="let obj of cascading_items">
                <tr class="row_cascading">
                <td style="padding-left: 1rem;">{{obj.quotation_data.boq_number}}</td>  
                <!-- <td><div>Ideal</div><div>Expected</div><div>Actual</div></td> -->
                <td>{{obj.quotation_data.tags | qwert}}</td>
                <!-- <td>{{obj.quotation_data.tags }}</td> -->
                <td>{{obj.quotation_data.timeline["Initial BOQ shared"] | date:'dd/MM/yyyy - h:mm a'}}</td>
                <td>{{obj.quotation_data.timeline["Initial BOQ accepted"] | date:'dd/MM/yyyy - h:mm a'}}</td>
                <td>{{obj.quotation_data.per_10_data.date}}<span *ngIf="obj.quotation_data.per_10_data.data" class="pl-1"><a data-toggle="modal" data-target="#tanquoteModal" ><i
                      style="font-size:20px; cursor: pointer;" (click)="tenquotepayment(obj.quotation_data.per_10_data.data)" class="fa ">&#xf05a;</i></a></span></td>

                 <!--10% payemn ends here-->     

                 <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["Final BOQ Category Handover"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["Final BOQ Category Handover"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["Final BOQ Category Handover"][0].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                 <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["Final BOQ Category Approved"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["Final BOQ Category Approved"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["Final BOQ Category Approved"][0].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                 <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["Final BOQ Shared"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["Final BOQ Shared"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["Final BOQ Shared"][0].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                 <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["Final BOQ approved"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["Final BOQ approved"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["Final BOQ approved"][0].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].actual | date:'dd/MM/yyyy - h:mm a'}}<span *ngIf="obj.quotation_data.forty_per_payment.data" class="pl-1"><a data-toggle="modal" data-target="#fortyquoteModal" ><i
                      style="font-size:20px; cursor: pointer;" (click)="fortyquotepayment(obj.quotation_data.forty_per_payment.data)" class="fa ">&#xf05a;</i></a></span></div></td>
                      <td><div><b>Ideal</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].ideal | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Expected</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].expected | date:'dd/MM/yyyy - h:mm a'}}</div><div><b>Actual</b> - {{obj.quotation_data.timeline["40% payment mapped (Sent to Production)"][0].actual | date:'dd/MM/yyyy - h:mm a'}}</div></td>
                </tr>
                </ng-container>
              </table>
            </td>
              </tr>
              <!-- </ng-container> -->
              <!--Cascading View Ends here-->
            </ng-container>
        </table>
        <div class="text-center">
          <pagination-controls autoHide="true" (pageChange)="current_page = getItems($event,'', 1,'','','','','','','','','','')"></pagination-controls>
         </div>
      </div>
    </div>
  </div>

  <!--Ten% Payment Modal-->
  <div id="tanModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <!-- <div class="vertical-alignment-helper"> -->
    <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
      <div class="modal-content modal-change">
        <div class="modal-header" style="background-color: azure;">
          <h4 class="modal-title">10% Payment Details</h4>
          <div class="iconbox">
            <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
          </div>
        </div>
        <div class="modal-body modal-body-change p-4">
          <table>
            <tr>
            <th class="text-center">Reference Number</th>
            <th class="text-center">Total Amount</th>
            <th class="text-center">Paid Amount</th>
            <th class="text-center">Closure Reported Status</th>
            </tr>
            <ng-container *ngFor="let ten_payment of tenData">
              <tr>
              <td class="detailscolor text-center">{{ten_payment.reference_number}}</td>
              <td class="detailscolor text-center">₹ {{ten_payment.total_amount}}</td>
              <td class="detailscolor text-center">₹ {{ten_payment.paid_amount}}</td>
              <td class="detailscolor text-center" *ngIf="ten_payment.per_10_approved_at">Accepted</td>
              <td class="detailscolor text-center" *ngIf="!ten_payment.per_10_approved_at">Pending</td>
              </tr>
              </ng-container>
            </table>
      </div>
    </div>
  </div>
  </div>
  <!--Ten% Payment Modal ends here-->

  <!--40% Payment Modal-->
  <div id="fortyModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <!-- <div class="vertical-alignment-helper"> -->
    <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
      <div class="modal-content modal-change">
        <div class="modal-header" style="background-color: azure;">
          <h4 class="modal-title">40% Payment Details</h4>
          <div class="iconbox">
            <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
          </div>
        </div>
        <div class="modal-body modal-body-change p-4">
          <table>
            <tr>
            <th class="text-center">Reference Number</th>
            <th class="text-center">Total Amount</th>
            <th class="text-center">Paid Amount</th>
            <th class="text-center">Sent To Production</th>
            </tr>
            <ng-container *ngFor="let forty_payment of fortyData">
              <tr>
              <td class="detailscolor text-center">{{forty_payment.reference_number}}</td>
              <td class="detailscolor text-center">₹ {{forty_payment.total_amount}}</td>
              <td class="detailscolor text-center">₹ {{forty_payment.paid_amount}}</td>
              <td class="detailscolor text-center" *ngIf="forty_payment.per_50_approved_at">Accepted</td>
              <td class="detailscolor text-center" *ngIf="!forty_payment.per_50_approved_at">Pending</td>
              </tr>
              </ng-container>
            </table>
      </div>
    </div>
  </div>
  </div>
  <!--40% Payment Modal ends here-->

  <!--First Meeting Modal-->
  <div id="firstmeetingModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <!-- <div class="vertical-alignment-helper"> -->
    <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
      <div class="modal-content modal-change">
        <div class="modal-header" style="background-color: azure;">
          <h4 class="modal-title">First Meeting Details</h4>
          <div class="iconbox">
            <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
          </div>
        </div>
        <div class="modal-body modal-body-change p-4">
          <div class="row justify-content-center">
            <div class="col-md-10">
           <div class="row">   
          <div class="col-md-6">Id:</div>
          <div class="col-md-6 detailscolor">{{firstMeetingData?.id}}</div>
          </div>
          <div class="row">   
            <div class="col-md-6">Agenda:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.agenda | replaceChar}}</div>
            </div>
            <div class="row">   
            <div class="col-md-6">Description:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.description}}</div>
            </div>  
            <div class="row">   
            <div class="col-md-6">Scheduled Date:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.scheduled_at | date:'dd/MM/yyyy'}}</div>
            </div> 
            <div class="row">   
            <div class="col-md-6">Status:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.status}}</div>
            </div>
            <div class="row">   
            <div class="col-md-6">Created At:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.created_at | date:'dd/MM/yyyy'}}</div>
            </div> 
            <div class="row">   
            <div class="col-md-6">Contact Type:</div>
            <div class="col-md-6 detailscolor">{{firstMeetingData?.contact_type | replaceChar}}</div>
            </div> 
          </div>
          
        </div>
      </div>
    </div>
  </div>
  </div>
  <!--First Meeting Modal ends here-->


  <!--cascading 10% payment Modal-->
  <div id="tanquoteModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <!-- <div class="vertical-alignment-helper"> -->
    <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
      <div class="modal-content modal-change">
        <div class="modal-header" style="background-color: azure;">
          <h4 class="modal-title">10% Payment Details</h4>
          <div class="iconbox">
            <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
          </div>
        </div>
        <div class="modal-body modal-body-change p-4">
          <div class="row justify-content-center">
            <div class="col-md-10">
           <div class="row">   
          <div class="col-md-6">Reference Number:</div>
          <div class="col-md-6 detailscolor">{{tenquoteData?.reference_number}}</div>
          </div>
          <div class="row">   
            <div class="col-md-6">Total Amount:</div>
            <div class="col-md-6 detailscolor">{{tenquoteData?.total_amount}}</div>
            </div>
            <div class="row">   
            <div class="col-md-6">Paid Amount:</div>
            <div class="col-md-6 detailscolor">{{tenquoteData?.paid_amount}}</div>
            </div> 
            <div class="row" *ngIf="tenquoteData?.per_10_approved_at">   
            <div class="col-md-6">Closed Reported Status:</div>
            <div class="col-md-6 detailscolor">Accepted</div>
            </div>  
            <div class="row" *ngIf="!tenquoteData?.per_10_approved_at">   
              <div class="col-md-6">Closed Reported Status:</div>
              <div class="col-md-6 detailscolor">Pending</div>
              </div> 
          </div>
          
        </div>
      </div>
    </div>
  </div>
  </div>
  <!--cascading 10% payment Modal ends here-->


   <!--cascading 40% payment Modal-->
   <div id="fortyquoteModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <!-- <div class="vertical-alignment-helper"> -->
    <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
      <div class="modal-content modal-change">
        <div class="modal-header" style="background-color: azure;">
          <h4 class="modal-title">40% Payment Details</h4>
          <div class="iconbox">
            <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
          </div>
        </div>
        <div class="modal-body modal-body-change p-4">
          <div class="row justify-content-center">
            <div class="col-md-10">
           <div class="row">   
          <div class="col-md-6">Reference Number:</div>
          <div class="col-md-6 detailscolor">{{fortyquoteData?.reference_number}}</div>
          </div>
          <div class="row">   
            <div class="col-md-6">Total Amount:</div>
            <div class="col-md-6 detailscolor">{{fortyquoteData?.total_amount}}</div>
            </div>
            <div class="row">   
            <div class="col-md-6">Paid Amount:</div>
            <div class="col-md-6 detailscolor">{{fortyquoteData?.paid_amount}}</div>
            </div> 
            <div class="row" *ngIf="fortyquoteData?.per_50_approved_at">   
            <div class="col-md-6">Sent To Production:</div>
            <div class="col-md-6 detailscolor">Accepted</div>
            </div>  
            <div class="row" *ngIf="!fortyquoteData?.per_50_approved_at">   
              <div class="col-md-6">Sent To Production:</div>
              <div class="col-md-6 detailscolor">Pending</div>
              </div> 
          </div>
          
        </div>
      </div>
    </div>
  </div>
  </div>
  <!--cascading 40% payment Modal ends here-->


// WEBPACK FOOTER //
// ./src/app/platform/organisation/zero-to-forty/zero-to-forty.component.html